import React from 'react';

export default function Tooltip({ tip }) {
  return (
    <span className="tooltip medium tooltip-direction">{ tip }</span>
  );
}



// WEBPACK FOOTER //
// ./src/universal/ui/components/Tooltip.js